<template>
    <aside class="settings-content settings-team">
        <Scrollbar class="data-list" :show_bar="true">
            <div class="header">
                <div class="left">
                    <div class="title">Team</div>
                    <!-- <div class="desc">Collaborate with other members of your team in the Anchor portal. </div> -->
                </div>

                <div class="select-as-button"
                    v-if="(isOwner || isAdmin) && !is_loading && !$store.state.merchant_disabeld && !noEditList">
                    <el-button @click="openSelect" >Manage roles & company<svg-icon name="arrow" /></el-button>

                    <el-select ref="hiddenSelect" default-first-option :reserve-keyword="false">
                        <el-option v-for="item in edit_list" v-show="item.show" :key="item.id" :label="item.name" :value="item.id"
                            @click="pickSelect(item)"/>
                    </el-select>
                </div>

                <el-button type="primary" v-if="(isOwner || isAdmin) && !is_loading && !$store.state.merchant_disabeld && permission_team.inviteTeammates.permission"
                    :disabled="current_user >= maxUser" @click="addTeammate">Invite Teammate</el-button>
            </div>

            <!-- <Pagenavi :disabled="current_user < 1" :page_current="list_parms.page" :page_total="total_page"
                @goto-page="gotoPage" /> -->

            <SettingAlert v-if="(isOwner || isAdmin) && current_user >= maxUser" :className="'yellow'">
                <p>You’ve reached your account limit.
                    <!-- <router-link :to="'/help'"> Contact us</router-link> -->
                    <a :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade number of user seats&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`"
                        target="_blank">Contact us</a>
                    to upgrade your plan.
                </p>
            </SettingAlert>

            <Table :style="top" :class="{ 'is-loading': is_loading }">
                <template #head>
                    <tr>
                        <th><span>Member ({{ current_user }}/{{ maxUser }})</span></th>
                        <th><span>Last Activity</span></th>
                        <th class="btn-th"><span>Role</span></th>
                        <th class="btn-th"><span>Company/Team</span></th>
                        <th></th>
                    </tr>
                </template>
                <template #body :key="key_refrash">
                    <template v-if="!is_loading && data.length === 0">
                        <tr>
                            <td colspan="10">
                                <NoData />
                            </td>
                        </tr>
                    </template>
                    <tr v-for="(row, index) in data" :key="index">
                        <td class="user-info">
                            <div class="profile">
                                <img :src="handleAvatar(row.avatar)" @error="imageError($event)" />
                            </div>
                            <div class="desc">
                                <span class="name">
                                    {{ row.name }}
                                    <span class="you" v-if="row.id === $store.state.user_data.id"> (You)</span>
                                    <tippy v-if="row.is_motom_internal_user"
                                        content="Motom internal staff, not visible to the public">
                                        <svg-icon name="logo-m" />
                                    </tippy>
                                </span>
                                <span class="status" v-if="row.email && row.status_text">
                                    {{ row.email }} • {{ row.status_text }}
                                </span>
                                <span class="status" v-else>
                                    {{ row.email }}{{ row.status_text }}
                                </span>
                            </div>
                        </td>
                        <td>
                            {{ row.last_time }}
                        </td>
                        <td class="role-td">
                            <div class="select-as-button select-as-button-no-border">
                                <el-button @click.stop="openRoleSelect(index, row)">
                                    <p>{{ row.role_name }}</p>
                                    <svg-icon
                                        v-if=" handleRow(row) && permission_team.assignRoleAndCompanyOrTeamToTeammates.permission"
                                        name="arrow" />
                                </el-button>

                                <el-select ref="roleHiddenSelect" default-first-option :reserve-keyword="false"
                                    @change="(val) => RoleSelect(val, row)">
                                    <el-option
                                        v-for="item in filteredRoles(row)"
                                        :key="item.role_id" :label="item.name" :value="item.role_name" />
                                </el-select>
                            </div>
                        </td>
                        <td class="role-td">
                            <div class="select-as-button  select-as-button-no-border">
                                <el-button :key="row.company_name" @click.stop="openCompanySelect(index, row)">
                                    <p>{{ row.company_name ? row.company_name : '---'
                                        }}</p><svg-icon name="arrow"
                                        v-if=" handleRow(row) && permission_team.assignRoleAndCompanyOrTeamToTeammates.permission" />
                                </el-button>

                                <el-select ref="hiddenCompanySelect" default-first-option :reserve-keyword="false"
                                    @change="(val) => CompanySelect(val, row)">
                                    <el-option v-for="item in companyList" :key="item.id" :label="item.name"
                                        :value="item.name" />
                                </el-select>
                            </div>
                        </td>
                        <td @click.stop="openMenu(row, $event)" v-if=" handleRow(row) && permission_team.manageTeammates.permission"
                            :class="[{ 'direction--top': row.on_bottom }]">
                            <svg-icon name="menu" />
                            <div class="handle-menu" v-show="row.menu_open">
                                <ul>
                                    <li v-for="(item, key) in handle_menu" class="menu-item" :key="key"
                                        v-show="row.last_type == item.type" @click="openDialog(item.text, row)">
                                        <span v-html="item.text"></span>
                                    </li>
                                </ul>
                            </div>
                        </td>
                        <td v-else style="cursor: default;"></td>
                    </tr>
                </template>
            </Table>
        </Scrollbar>
    </aside>

    <!-- <AddUser ref="add" @needRefrash="needRefrash" :key="add_refrash" :data="data" :companys="companys" /> -->
    <AddUserNew ref="add" @needRefrash="needRefrash" :key="add_refrash" :data="data" :companys="companyList"
        :roles="permissionRoles" />
    <TeamEditDrawer ref="teamDrawer" @refrash="getList" />

    <!-- handle dialog -->
    <el-dialog :title="dialogValue.title" width="400" v-model="handleDialogOpen"
        @close="handleDialogOpen = false; handleOwnerLeaveListIndex = null" class="handle-dialog">
        <p>{{ dialogValue.content }}</p>
        <el-select v-model="handleOwnerLeaveListIndex" v-if="handleDialog === 3 || handleDialog === 1" :reserve-keyword="false">
            <el-option v-for="item in handleOwnerLeaveList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <div class="btn-row">
            <el-button @click="handleDialogOpen = false" type="text">Cancel</el-button>
            <el-button type="danger" :disabled="handleDialog === 3 || handleDialog === 1 ? !handleOwnerLeaveListIndex : false"
                @click="handleListMenu()">{{ dialogValue.btn }}</el-button>
        </div>
    </el-dialog>

    <!-- identity dialog -->
    <IdenityDialog ref="idDia" @remove-user="getList()" :handleDialog="handleDialog"/>
</template>

<script>
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Table from '@/components/ui/Table.vue';
import AddUserNew from '@/components/settings/Team/AddUserNew.vue';
import NoData from '@/components/creator/NoData.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import CheckArray from '@/utils/CheckArray';
import SettingAlert from '@/components/settings/SettingAlert.vue';
import TeamEditDrawer from '@/components/settings/Team/TeamEditDrawer.vue';
import { ElSelect, ElOption, ElButton, ElDialog, ElInput } from 'element-plus';
import Loading from '@/components/ui/Loading.vue';
import IdenityDialog from '@/components/settings/IdenityDialog.vue';

export default {
    name: 'Team',

    components: {
        Scrollbar,
        Table,
        AddUserNew,
        NoData,
        Pagenavi,
        SettingAlert,
        ElSelect,
        ElOption,
        TeamEditDrawer,
        ElButton,
        ElDialog,
        ElInput,
        Loading,
        IdenityDialog
    },

    data() {
        return {
            is_loading: true,
            data: [],
            current_user: 0,
            top: '--top: 0px',
            list_parms: {
                page: 1,
                per_page: 100
            },
            total_page: 0,
            select_user_data: null,
            //type 1=is trams,2=invited
            handle_menu: [
                {
                    text: 'Remove',
                    type: 1,
                    success_mes: 'Teammate removed'
                },
                {
                    text: 'Cancel',
                    type: 2,
                    success_mes: 'Invite canceled'
                },
                {
                    text: 'Resend invite',
                    type: 2,
                    success_mes: 'Invite resent'
                },
                {
                    text: 'Leave and transfer ownership',
                    type: 3,
                    success_mes: 'Teammate removed'
                },
            ],
            key_refrash: 0,
            add_refrash: 0,
            //9625 new
            edit_pick: 1,
            handleDialogOpen: false,
            handleDialog: 1,
            handleNowUser: null,
            handleOwnerLeaveList: [],
            handleOwnerLeaveListIndex: null,
            //9625 new
            permissionRoles: [],
            companyList: [],
        }
    },

    computed: {
        permission_team(){
            return this.$store.state.user_data?.permission_list?.settingWorkspace;
        },
        edit_list() {
            return [
                { id: 1, name: 'Manage roles' , show:this.permission_team.createAndEditAndManageCustomCompanyOrTeam.permission},
                { id: 2, name: 'Manage company' ,show:this.permission_team.createAndEditAndManageCustomRoles.permission},
            ]
        },
        noEditList(){
            return !this.permission_team.createAndEditAndManageCustomCompanyOrTeam.permission && !this.permission_team.createAndEditAndManageCustomRoles.permission;
        },
        maxUser() {
            return this.$store.state.user_data.merchant_account.portal_user_max_count;
        },
        dialogValue() {
            let mer_name = this.$store.state.user_data.merchant_account.merchant_display_name;
            let is_me=this.handleNowUser?.id === this.$store.state.user_data.id;
            if (this.handleDialog == 1) {
                return {
                    title: 'Transfer ownership',
                    content: `You’re about to transfer ownership of the ${mer_name} portal${is_me? '. you’ll need to transfer ownership.': ` to ${this.handleNowUser?.name}.`} Once confirmed, you’ll become an admin, and ownership can only be assigned to an existing admin.`,
                    btn: 'Transfer ownership',
                }
            } else if (this.handleDialog == 2) {
                return {
                    title: 'Leave this team',
                    content: `Leaving this team will revoke your access to the dashboard and data associated with this workspace. You’ll still be able to access any other workspaces with your current login, if applicable.`,
                    btn: 'Confirm',
                }
            }
            //this one need to save other user
            else if (this.handleDialog == 3) {
                return {
                    title: 'Leave team and transfer ownership',
                    content: `To leave the ${mer_name} portal workspace, you’ll need to transfer ownership.  Once ownership is reassigned, you will then be able to leave the workspace.`,
                    btn: 'Transfer ownership',
                }
            } else if (this.handleDialog == 4) {
                return {
                    title: 'Remove a member',
                    content: `Removing ${this.handleNowUser.name} from the ${mer_name} portal will revoke their access to this workspace.`,
                    btn: 'Remove member',
                }
            }
        },
        isOwner() {
            let val = this.$store.state.user_data.permission_list;
            return val?.role_type === 100 || val?.role_type === 200;
        },
        isAdmin() {
            let val = this.$store.state.user_data.permission_list;
            return val?.role_type === 80;
        },
    },

    methods: {
        start() {
            this.getList();
        },

        handleRow(row) {
            const currentUser = this.$store.state.user_data;

            return (
                (this.isOwner && (
                (row.role_type !== 100 && row.role_type !== 200) ||
                (currentUser.id === row.id)  // 自己可以操作自己
                )) ||
                (this.isAdmin && row.role_type !== 100)
            );
        },

        filteredRoles(row) {
            const currentUserRoleType = this.$store.state.user_data.permission_list?.role_type;

            return this.permissionRoles.filter(e => {
                // 排除同個角色 id
                if (e.id === row.role_id) {
                return false;
                }

                // isOwner: 使用者為 100 或 200
                const isOwner = currentUserRoleType === 100 || currentUserRoleType === 200;

                // isAdmin: 使用者為 80
                const isAdmin = currentUserRoleType === 80;

                // 如果是 Owner 且 row 還沒呼叫 API，排除 type 為 100/200
                if (isOwner && !row.last_api_call_at && (e.role_type === 100 || e.role_type === 200)) {
                return false;
                }

                // Owner 的角色互斥邏輯：
                // 使用者是 100 → 不能編輯 200
                if (currentUserRoleType === 100 && e.role_type === 200) {
                return false;
                }

                // 使用者是 200 → 不能編輯 100
                if (currentUserRoleType === 200 && e.role_type === 100) {
                return false;
                }

                // Admin 不可操作 100/200
                if (isAdmin && (e.role_type === 100 || e.role_type === 200)) {
                return false;
                }

                return true;
            });
        },

        //++++++++++++++++++++++++++++++++++++++++
        //select change
        //++++++++++++++++++++++++++++++++++++++++
        openRoleSelect(index, row) {
            if(!this.permission_team.assignRoleAndCompanyOrTeamToTeammates.permission){
                return;
            }

            if (!this.handleRow(row)) {
                return;
            }

            const selectRefs = this.$refs.roleHiddenSelect;
            const targetSelect = Array.isArray(selectRefs) ? selectRefs[index] : selectRefs;
            if (targetSelect) {
                targetSelect.toggleMenu(); // 正確開啟下拉
            }
        },

        openCompanySelect(index, row) {
            if(!this.permission_team.assignRoleAndCompanyOrTeamToTeammates.permission){
                return;
            }

            if (!this.handleRow(row)) {
                return
            }
            const selectRefs = this.$refs.hiddenCompanySelect;
            const targetSelect = Array.isArray(selectRefs) ? selectRefs[index] : selectRefs;
            if (targetSelect) {
                targetSelect.toggleMenu(); // 正確開啟下拉
            }
        },

        RoleSelect(val, row) {

            let role = this.permissionRoles.find(item => item.name === val);
            if (role.role_type === 100 || (this.isOwner && this.$store.state.user_data.id === row.id) ) {
                this.handleNowUser = row;
                if(!(this.isOwner && this.$store.state.user_data.id === row.id)){
                    let idx = this.handleOwnerLeaveList.findIndex(e => e.id === row.id);
                    this.handleOwnerLeaveListIndex= this.handleOwnerLeaveList[idx].id;
                }else{
                    this.handleOwnerLeaveListIndex = null;
                }

                let type= 1//role.role_type === 100 || role.role_type === 200? 3:1;
                this.handleDialog = type;
                this.handleDialogOpen = true;
                return;
            };

            row.role_name = val;
            this.callRoleChangeApi(row.id, role.id);
        },

        CompanySelect(val, row) {
            row.company_name = val;
            let formData = new FormData();
            let role = this.companyList.find(item => item.name === val);
            formData.append('portal_user_id', row.id);
            formData.append('company_id', role.id);
            this.is_loading = true;
            this.$ajax.post('/settings/update-user-company', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                this.is_loading = false;
            })
        },
        //+++++++++++++++++++++++++++++++++++
        getList() {
            const params = Object.entries(this.list_parms).map(([key, val]) => `${key}=${val}`).join('&');
            this.is_loading = true;
            let api = `/settings/get-team-user-list`;//settings/portal-user-list?${params};(9625 change api)

            // 1. 先 call 三隻 API 並行處理
            Promise.all([
                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }),
                this.$ajax('/settings/get-permission-role-list', {
                    method: 'get',
                    withCredentials: true,
                }),
                this.$ajax('/settings/get-company-list', {
                    method: 'get',
                    withCredentials: true,
                }),
            ])
                .then(([userRes, roleRes, companyRes]) => {
                    this.data = [];
                    // --- 處理 user list 資料 ---
                    userRes.data.data.forEach((e, k) => {
                        if (e.last_api_call_at) {
                            e.last_time = this.$filters.momentFormat(e.last_api_call_at, 'll');
                            e.last_type = 1;
                            if (e.role_type === 100 || e.role_type === 200) {
                                e.last_type = 3;
                            }
                        } else {
                            e.last_time = 'Invited';
                            e.last_type = 2;
                        }

                        e.on_bottom = false;
                        e.menu_open = false;
                        if (this.$store.state.user_data.is_motom_internal_user) {
                            this.data.push(e);
                        } else {
                            if (!e.is_motom_internal_user) {
                                this.data.push(e);
                            }
                        }

                    });
                    this.handleOwnerLeaveList = userRes.data.data.filter(e => (e.id !== this.$store.state.user_data.id) && e.last_api_call_at);
                    this.current_user = this.data.filter(e => !e.is_motom_internal_user).length;//userRes.data.data.current_user_count;
                    this.total_page = userRes.data.data.last_page;

                    // --- 處理 role list 資料 ---
                    this.permissionRoles = roleRes.data.data.map(item => ({
                        ...item,
                        name: item.role_name,
                        isDefault: item.role_name === 'owner' || item.role_name === 'admin',
                        isOwner: item.role_name === 'owner',
                        isInternal: item.role_name === 'owner' || item.role_name === 'admin',
                    }));

                    // --- 處理 company list 資料 ---
                    this.companyList = companyRes.data.data.map(item => ({
                        ...item,
                        name: item.company_name,
                    }));

                    this.key_refrash += 1;
                    this.is_loading = false;
                })
                .catch(error => {
                    console.error('API Error:', error);
                    this.is_loading = false;
                });
        },

        handleAvatar(imgUrl) {
            if (imgUrl)
                return imgUrl;
            else
                return require('@/assets/images/user.png');
        },

        gotoPage(page) {
            this.list_parms.page = page;
            this.getList()
        },

        imageError(event) {
            event.target.src = require('@/assets/images/user.png');
        },

        cancelOrResend(id, name, title) {
            this.is_loading = true;
            let form_data = name == 'delete' ? {} : new FormData();

            if (name == 'cancel' || name == 'resend-invite') {
                form_data.append('portal_user_id', Number(id));
                this.callTeamsApi(name, form_data, title);
            };
        },

        removeUser(id) {
            this.is_loading = true;
            let formData = new FormData();
            formData.append('remove_portal_user_id', id);

            this.$ajax.post(`/settings/remove-merchant-user`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                this.$refs.idDia.close();
                this.handleDialogOpen = false;
                this.successNofity(`Remove user successfully`);
                if (this.$store.state.user_data.id == id) {
                    setTimeout(e => {
                        window.location.href = '/landing';
                    }, 1000);
                    return;
                }
                this.getList();

            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        formatName(input) {
            return input
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },

        callTeamsApi(name, form_data, title) {
            let api = '';
            if (name == 'delete') {
                api = '/settings/kick-user-from-team';
            } else {
                api = `/settings/${name}-portal-user`;
            }

            this.$ajax(`${api}`, {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.is_loading = false;
                this.list_parms.page = 1;
                this.getList();
                this.successNofity(`${this.formatName(name)} successfully`);
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        openDialog(name, row) {
            this.handleNowUser = row;

            if (name === 'Remove' || name === 'Leave and transfer ownership') {
                //owner可以移除自己但要先讓其他人當owner(不同彈出視窗)
                //admin可以移除owner以外的人
                this.handleOwnerLeaveListIndex=null;
                if (this.isOwner && this.$store.state.user_data.id == row.id) {
                    this.handleDialog = 3;
                } else if (this.$store.state.user_data.id == row.id) {
                    this.handleDialog = 2;
                } else {
                    this.handleDialog = 4;
                }
                this.handleDialogOpen = true;
            }
            else {
                this.handleListMenu(name, row.id);
            }

        },

        handleListMenu(name, id) {

            if (name == 'Resend invite')
                this.cancelOrResend(id, 'resend-invite', this.handle_menu[2].success_mes)

            if (name == 'Cancel')
                this.cancelOrResend(id, 'cancel', this.handle_menu[1].success_mes)

            if (!name) {
                this.handleDialogOpen = false;
                if (this.handleDialog === 1 || this.handleDialog === 3) {
                    
                    this.handleNowUser = this.data.filter(e => e.id == this.handleOwnerLeaveListIndex)[0];
     
                    this.$refs.idDia.open(1,this.handleNowUser);
                } else if (this.handleDialog === 2 || this.handleDialog === 4) {
                    this.removeUser(this.handleNowUser.id);
                }
            }
        },

        async callRoleChangeApi(por, role) {
            try {
                const formData = new FormData();
                formData.append('portal_user_ids[]', por);
                formData.append('role_id', role);
                this.is_loading = true;

                await this.$ajax.post('/settings/assign-role-to-user', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                if (this.$store.state.user_data.id == por) {
                    window.location.reload();
                } else {
                    this.getList();
                }
                this.successNofity(`Role change successfully`);

            } catch (error) {
                console.error('Role change API failed:', error);
            } finally {
                this.is_loading = false;
            }
        },

        needRefrash(val) {
            this.add_refrash += 1;
            if (val.refrash_api) {
                this.list_parms.page = 1;
                this.getList();
            }
        },

        addTeammate() {

            if ((this.isOwner || this.isAdmin) && this.current_user < this.maxUser) {
                this.$refs.add.open();
            }
        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify({
                text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
                </svg>
                ${mes}`,
                group: 'white',
                type: 'warn',
            });
        },

        successNofity(mes) {
            this.$notify({
                text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                    </svg> ${mes}.`,
                group: 'white',
                type: 'success',
            });
        },

        openMenu(row, $el) {

            // console.log($el.target.getBoundingClientRect())
            this.data.forEach((e, k) => {
                if (e.id === row.id && e.menu_open === false) {
                    e.menu_open = true;
                    const rect = $el.target.getBoundingClientRect();
                    e.on_bottom = rect.bottom > (window.innerHeight - 100);
                } else {
                    e.menu_open = false;
                }
            });

            if (this.$refs.dropdown_source) this.$refs.dropdown_source.forEach((e) => {
                e.is_show_select = false;
            });
        },

        handleClick() {
            this.data.forEach((e, k) => {
                e.menu_open = false;
            });
        },

        openSelect() {
            this.$refs.hiddenSelect.toggleMenu();
        },

        pickSelect(item) {
            this.$refs.teamDrawer.open(item);
        },
    },

    created() {
        window.addEventListener('click', this.handleClick);
    },

    destroyed() {
        window.removeEventListener('click', this.handleClick);
    },

    mounted() {

        this.start();
    },
}
</script>
<style lang="scss">
.settings-team {
    width: 263px;
    padding-right: 0 !important;

    .span {
        padding: 0 16px;
    }

    .select-as-button {
        position: relative;
        margin-right: 8px;


        .el-select {
            position: absolute;
            left: 0;
            z-index: -1;
        }

        svg {
            width: 10px;
            height: 10px;
            margin-left: 8px;
            margin-top: 2px;
        }

        &.select-as-button-no-border {
            .el-button {
                border: none;
                width: 100%;
                justify-content: space-between;

                span {
                    width: 100%;
                }

                p {
                    flex: 1;
                    text-align: left;
                    font: var(--font-fg-12);
                }
            }

            svg {
                width: 8px;
                height: 8px;
            }
        }

    }

    .header {
        display: flex;
        align-items: center;

        .left {
            flex: 1;

            .desc {
                margin-top: 8px;
                font-family: var(--font);
                font-weight: 400;
                font-size: 14px;

                span {
                    color: var(--blue);
                }
            }
        }

        .disabled {
            cursor: not-allowed;
        }

        .disabled:hover {
            background-color: var(--black-20);
            color: var(--black-50);
        }
    }

    .ui-alert {
        margin-top: 16px;
        margin-bottom: 8px;
    }

    .ui-pagenavi {
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;
        margin-right: 64px; //accommodation to table
    }

    .scrollbar-content {
        padding-right: 64px; //accommodation to table
    }

    .ui-table {
        margin-top: 10px;
        min-height: 82px;

        &.is-loading {

            &::before {
                // bottom: 16px;
                top: calc(50% + 10px);

            }
        }

        .btn-th{
            span{
                margin-left: 16px;
            }
        }


        thead tr {
            border-top: 1px solid var(--black-20);
        }

        td {
            font: var(--font-fg-12);
            color: var(--black-60);
            position: relative;

            .you {
                color: var(--black-60);
            }

            .svg-icon--next {
                width: 7px;
                height: 7px;
                transform: rotate(90deg);
            }

            .svg-icon--menu {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }


            &:last-child {
                position: relative;
                cursor: pointer;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }

        tr:hover .ui-button {
            background-color: var(--bg-10);
        }

        .user-info {
            display: flex;
            align-items: center;

            .profile {
                margin-right: 8px;

                img {
                    width: 32px;
                    height: 32px;
                }
            }

            .desc {

                .name {
                    font: var(--font-fg-12);
                    color: var(--black-90);
                    display: flex;
                    align-items: center;

                    svg {
                        height: 12px;
                        width: 12px;
                        margin-left: 4px;
                        display: block;
                    }
                }

                .status {
                    font-family: var(--font);
                    font-weight: 400;
                    font-size: 12px;
                    color: var(--black-60);
                }
            }
        }

        .role-td {
            .ui-button {
                border: none;
                width: 100%;
                padding: 0 !important;
                justify-content: initial;

                span {
                    text-transform: capitalize;
                    font: var(--font-fg-12);
                }
            }

            .ui-button:hover {
                background-color: var(--bg-10);
            }
        }

        .role-td .ui-dropdown--inner .item-box.direction--right {
            width: 100%;
            max-width: 100px;
            min-width: 74px;
            right: auto;
            left: 0;
        }

        .ui-dropdown.only-show {
            pointer-events: none;

            svg {
                opacity: 0;
            }
        }

        .role-td+td {
            width: 50px;
            position: relative;
        }

        .direction--top {
            .handle-menu {
                bottom: 65%;
            }
        }

        .handle-menu {
            padding: 8px 0;
            width: max-content;
            background: white;
            border: 1px solid #F2F2F2;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            position: absolute;
            z-index: 9;
            right: 0;

            .menu-item {
                padding: 9px 10px;
                display: flex;
                align-items: center;
                cursor: pointer;
                color: var(--black-90);
                font: unset;
                font-family: var(--font);
                font-size: 14px;

                &:hover {
                    background: var(--bg-02);
                }
            }

            &.open {
                display: block;
            }
        }
    }
}

.handle-dialog {
    .btn-row {
        margin-top: 16px;
        display: flex;
        gap: 8px;
        justify-content: flex-end;
    }

    label {
        margin: 8px 0;
    }

    .el-select {
        margin: 16px 0;
    }

    .err-text {
        color: var(--red);
        margin-top: 4px;
        text-align: right;
    }

    .step-1 {
        .input-box {
            position: relative;
            margin-top: 8px;
            width: 100%;
        }

        i {
            position: absolute;
            right: 16px;
            top: 8px;
            cursor: pointer;

            svg {
                width: 16px;
                height: 16px;
            }
        }
    }

    .step-2 {
        p {
            font-size: 16px;
        }

        .label-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 16px;

            .el-link {
                color: var(--blue);
                cursor: pointer;
            }
        }
    }
}
</style>
